<template>
    <div class="provider-selection-list">
        <b-collapse
            v-model="isSelected"
        >
            <b-card
                no-body
                border-variant="light"
                class="cursor-pointer mb-0"
            >
                <div class="card-header">
                    <div class="col-md-8 pl-0">
                        <b-form-radio
                            name="selected-provider"
                            class="cursor-pointer"
                            v-model="selected"
                            :value="selected instanceof Object ? selected : true"
                        >
                            <b-card-title class="ml-1">{{ selected instanceof Object ? selected.title : $t('Component(ProviderSelectionList):smtp-settings') }}</b-card-title>
                        </b-form-radio>
                    </div>
                    <div class="col-md-4 text-right">
                        <Button @click="expand">
                            {{ $t('Component(Button):change') }}
                        </Button>
                    </div>
                </div>
            </b-card>
        </b-collapse>
        <b-collapse
            v-model="expanded"
        >
            <b-input-group class="mb-1">
                <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" />
                </b-input-group-prepend>
                <b-form-input
                    :placeholder="$t('Component(ProviderSelectionList):placeholder-filter')"
                    v-model="searchString"
                    @input="onSearchInput"
                />
            </b-input-group>
            <vue-perfect-scrollbar
                ref="refChatLogPS"
                :settings="perfectScrollbarSettings"
                class="scroll-area pr-1"
            >
                <b-card
                    v-for="provider in visibleProviders"
                    @click.stop.prevent="selectProvider(provider)"
                    no-body
                    border-variant="light"
                    style="margin-bottom: 8px;"
                    class="cursor-pointer"
                >
                    <div class="card-header">
                        <div class="pl-0">
                            <b-form-radio
                                name="provider"
                                :value="provider"
                                v-model="selected"
                                class="cursor-pointer"
                            >
                                <b-card-title class="ml-1">{{ provider.title }}</b-card-title>
                            </b-form-radio>
                        </div>
                    </div>
                </b-card>
            </vue-perfect-scrollbar>
            <hr class="mr-1">
            <b-card
                no-body
                border-variant="light"
                class="cursor-pointer mr-1"
                @click="enterSmtp"
            >
                <div class="card-header">
                    <div class="pl-0">
                        <b-form-radio
                            name="provider"
                            class="cursor-pointer"
                        >
                            <b-card-title class="pl-1">{{ $t('Component(ProviderSelectionList):smtp-settings') }}</b-card-title>
                        </b-form-radio>
                    </div>
                </div>
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
import {SystemApi} from "@core/api";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {BCard, BCardTitle, BFormRadio, BFormInput, BInputGroup, BInputGroupPrepend, BCollapse} from 'bootstrap-vue'
import {Button} from "@core/components/common";

export default {
    components: {
        BCard, BCardTitle, BFormRadio, VuePerfectScrollbar, BFormInput, BInputGroup, BInputGroupPrepend, Button, BCollapse,
    },
    data() {
        return {
            providers: [],
            visibleProviders: [],
            selected: null,
            isSmtpSelected: false,
            perfectScrollbarSettings: {
                maxScrollbarLength: 150,
            },
            searchString: null,
            searchTimer: null,

            expanded: true,
            isSelected: false
        }
    },
    methods: {
        onSearchInput() {
            clearTimeout(this.searchTimer);
            if (!this.searchString) {
                this.visibleProviders = this.providers;
            } else {
                this.searchTimer = setTimeout(() => {
                    this.filterVisibleElements();
                }, 600);
            }
        },
        filterVisibleElements() {
            this.visibleProviders = this.providers.filter(p => {
                return p.title.toLowerCase().indexOf(this.searchString) >= 0;
            });
        },
        selectProvider(provider) {
            this.selected = provider;
            this.$emit('selected', {
                isProvider: true,
                isSmtp: false,
                provider
            });
            this.collapse();
            this.searchString = '';
            this.filterVisibleElements();
        },
        enterSmtp() {
            this.$emit('selected', {
                isProvider: false,
                isSmtp: true,
            });
            this.selected = true;
            this.collapse();
        },
        collapse() {
            this.expanded = false;
            this.isSelected = true;
        },
        expand() {
            this.expanded = true;
            this.isSelected = false;
        }
    },
    created() {
        SystemApi.email.getProviders().then(r => {
            this.visibleProviders = this.providers = r.data;
        });
    },
}
</script>

<style lang="scss">
.provider-selection-list .scroll-area {
    position: relative;
    margin: auto;
    max-height: 288px;
}
</style>
